<template>
  <component :is="switchTheme"></component>
</template>

<script>
import { siteMixin } from "../../utils/mixin";
import AppHeaderBlack from "./AppHeaderBlack";
import AppHeaderWhite from "./AppHeaderWhite";
export default {
  mixins: [siteMixin],
  data() {
    return {
      black: AppHeaderBlack,
      white: AppHeaderWhite,
    };
  },
  computed: {
    switchTheme() {
      switch (this.siteConfig.theme) {
        case "overall":
          return this.black;
          break;
        default:
          return this.white;
          break;
      }
    },
  },
  methods: {},
  components: {
    AppHeaderBlack,
    AppHeaderWhite,
  },
};
</script>

<style lang="less">
@import "../../assets/css/var";
</style>